import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { buildPath } from '@e-socna/utils';
import { ActorListEnum } from '@e-socna/data-layer';

import {
  PATH_BUSINESS_EVENT_DEFAULT,
  PATH_MISSION_EXTERNAL_ACTORS_EDIT,
  PATH_MISSION_INTERNAL_ACTORS_EDIT,
} from '../../../../app/constants/paths.constant';
import { buildMissionPath } from '../../../../app/utils/mission-space.util';
import { NewTabButton } from '../../../../components/NewTabButton';

import type { ActorListsFreeze } from './hooks/useActorListsChangeFreezes.hook';

const LIST_LABELS: Readonly<Record<ActorListEnum, string>> = {
  [ActorListEnum.Internal]: 'acteurs internes',
  [ActorListEnum.External]: 'acteurs externes',
};

// Where the actors of a level are fixed: the list in question of a mission, the business event.
const actorsPathOf = (
  folderId: string,
  {
    businessEventId,
    compositeMissionId,
    lists,
    missionId,
    missionKind,
  }: Readonly<ActorListsFreeze>,
) => {
  if (businessEventId) {
    return buildPath(PATH_BUSINESS_EVENT_DEFAULT, { id: businessEventId });
  }

  if (!missionId || !missionKind) {
    return undefined;
  }

  return buildMissionPath(
    lists.includes(ActorListEnum.External)
      ? PATH_MISSION_EXTERNAL_ACTORS_EDIT
      : PATH_MISSION_INTERNAL_ACTORS_EDIT,
    { folderId, missionId, kind: missionKind, compositeMissionId },
  );
};

export const ActorListsChangeVerdict = ({
  folderId,
  verdict,
}: Readonly<{ folderId: string; verdict: ActorListsFreeze }>) => {
  const path = verdict.refusal ? actorsPathOf(folderId, verdict) : undefined;

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'flex-start' }}>
      {verdict.refusal ? (
        <CancelIcon color="error" fontSize="small" sx={{ mt: 0.25 }} />
      ) : (
        <CheckCircleIcon color="success" fontSize="small" sx={{ mt: 0.25 }} />
      )}
      <Stack spacing={0.5}>
        <Typography variant="body2">
          {verdict.refusal ??
            `${verdict.level} gardera ses ${verdict.lists.map((list) => LIST_LABELS[list]).join(' et ')} en propre.`}
        </Typography>
        {path ? (
          <div>
            <NewTabButton href={path} label="Modifier ses acteurs" />
          </div>
        ) : null}
      </Stack>
    </Stack>
  );
};
